import { Form } from 'common/components';

import WizardModal from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardModal';

import '../styles/Wizard.less';

export const ProductUploadWizard = ({
  visible,
  onClose,
  wizardFormId,
  showWizardContent,
}) => {
  const [formInstance] = Form.useForm();

  return (
    <Form form={formInstance}>
      <WizardModal
        visible={visible}
        onClose={onClose}
        wizardFormId={wizardFormId}
        showWizardContent={showWizardContent}
      />
    </Form>
  );
};

export default ProductUploadWizard;
